const environment = 'production';
let config = {};

switch (environment) {
	case 'local':
		config = {
			host: 'http://www.a.com/api',
			union: 'http://www.a.com'
		};
		break;
	case 'production':
		config = {
			host: 'http://consoleapi.alzheimer.org.cn/api',
			union: 'http://consoleapi.alzheimer.org.cn'
		};
		break;
	default:
		config = {
			host: 'http://cafe.dev.mindsgo.com/api',
			union: 'http://cafe.dev.mindsgo.com'
		};
}

let viewer = {
	dicomviewer: 'http://dicomviewer.alzheimer.org.cn',
	t1viewer: 'http://t1viewer.alzheimer.org.cn',
	petviewer: '',
	reportviewer: ''
};
const links = {
	download_encrypted: config.union + '/data/software/FileEncrypterInstall.zip',
	download_batchupload: config.union + '/data/software/BatchUploader.zip'
};

let services = {
	isbrainlabel: true
}

config = Object.assign(config, viewer, services, links);

export default config;


// WEBPACK FOOTER //
// ./src/apps/config.js